import {createRoot, hydrateRoot} from 'react-dom/client';
import TermsConditions from '../pages/TermsConditions/TermsConditions'
import "../index.css";
import "../pages/TermsConditions/TermsConditions.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<TermsConditions {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <TermsConditions {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).TermsConditionsVC = {mount, hydrate, unmount}